export enum ErrorCode {
	e401 = 401,
	e403 = 403,
	e404 = 404,
	e422 = 422,
	e500 = 500,
	e502 = 502,
	e503 = 503,
}
